(function () {
    'use strict';

    angular.module("imApp").factory("custactDeadLinesService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 3344,
                    parameters: parms || {}
                });
            },
            listDeadLines: function (parms) {
                return $ihttp.post({
                    method: 1012,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
